<template>
  <div>
    <card>
      <b-row class="pb-3">
        <b-col>
          <h2 class="pb-3">Administative Users</h2>
          <b-form-checkbox switch size="sm" v-model="active"
            >Active Users</b-form-checkbox
          >
        </b-col>
        <b-col class="text-right pb-3">
          <b-button variant="primary" role="button" href="/#/admin/adminuser/"
            >Add Administrator</b-button
          >
        </b-col>
      </b-row>

      <b-table
        id="adminUser"
        outlined
        hover
        :fields="[{ key: 'id' }, { key: 'name' }, { key: 'email' }]"
        :items="adminUsers"
        @row-clicked="rowClicked"
      ></b-table>
    </card>
  </div>
</template>

<script>
import BaseSwitch from "../../../components/BaseSwitch.vue";
export default {
  components: { BaseSwitch },
  data() {
    return {
      adminUsers: [],
      active: true,
    };
  },
  watch: {
    active: function(val) {
      this.bind();
    },
  },
  async mounted() {
    this.bind();
  },
  methods: {
    async bind() {
      var self = this;
      var r = await self.$client.get(
        "/api/user/admins?isActive=" + this.active
      );
      self.adminUsers = r.data.value.users;
    },
    rowClicked(item) {
      location.href = "/#/admin/adminUser/" + item.id;
    },
  },
};
</script>

<style>
#adminUser tr {
  /* Select the 3rd td */
  cursor: pointer;
}
</style>
